export const TIPO_DECLARACION_DECLARACION_MODELO = {
  C: 1,
  D: 2,
  G: 3,
  I: 4,
  N: 5,
  V: 6,
  U: 7,
  X: 8,
} as const

export type TipoDeclaracionDeclaracionModelo =
  (typeof TIPO_DECLARACION_DECLARACION_MODELO)[keyof typeof TIPO_DECLARACION_DECLARACION_MODELO]
